/** @format */
import { RefObject } from 'react';

import { MediaQuery } from '@toucan/client/global/application';
import { headerSizes } from '@toucan/client/global/layout';

/**
 * Detect if a given ref is scrolled to the bottom of its content or not
 *
 * @param {RefObject<HTMLElement>} ref - The Ref we are checking
 * @returns {boolean} - Returns true when the ref is scrolled to bottom
 */

export function isScrollAtBottom(ref: RefObject<HTMLElement>): boolean {
    const element = ref.current;
    if (!element) {
        return false;
    }

    return !(element.scrollHeight - (element.scrollTop + element.clientHeight));
}

/**
 * Scrolls the user to the Y coordinate that is passed to it
 * @param y The y coordinate to scroll to
 */
// eslint-disable-next-line id-length -- Legacy code: do not use as an example.
export function scrollToY(y: number) {
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Legacy code: do not use as an example.
    const supportsScrollToOptions =
        'scrollBehavior' in document.documentElement.style;

    if (supportsScrollToOptions) {
        window.scrollTo({
            top: y,
            behavior: 'smooth',
        });
    } else {
        window.scrollTo(0, y);
    }
}

/**
 * Scrolls an element into view
 *
 * @param element The element to scroll into view
 */
export function scrollToElement(element: HTMLElement | null) {
    if (!element) {
        return;
    }

    // Offsetting by the header height so the element will be in view even when the header is showing
    const offset = headerSizes[MediaQuery.DESKTOP].full;

    const { top } = element.getBoundingClientRect();
    // eslint-disable-next-line id-length -- Legacy code: do not use as an example.
    const y = top + window.pageYOffset - offset;

    scrollToY(y);
}

/**
 * Scrolls the user to the top of the page
 */
export function scrollToTop() {
    scrollToY(0);
}
